/**
 *
 * Submenu
 *
 */

import React, { memo } from 'react';
import PropTypes from 'prop-types';

import { PLACEMENTS } from './constants';
import { StyledSubmenu, SubmenuContainer } from './Menu.styles';

function Submenu({ children, open, placement = PLACEMENTS.RIGHT, ...props }) {
  return (
    <SubmenuContainer open={open} placement={placement} {...props}>
      <StyledSubmenu>{children}</StyledSubmenu>
    </SubmenuContainer>
  );
}

Submenu.propTypes = {
  children: PropTypes.node,
  open: PropTypes.bool,
  placement: PropTypes.oneOf(Object.values(PLACEMENTS)),
};

export default memo(Submenu);
